import { Fragment, FunctionComponent, useMemo } from 'react'
import useStyles from './styles'

const ProtectedSiteStamp: FunctionComponent = () => {
  const { stampSection } = useStyles()

  useMemo(() => {
    if (`${process.env.REACT_APP_API_URL}`.includes('hml')) return

    const externalScript = document.createElement('script')
    externalScript.setAttribute('src', '//cdn.siteblindado.com/aw.js')
    document.head.appendChild(externalScript)
  }, [])

  return (
    <Fragment>
      <div css={stampSection}>
        <div id="armored_website">
          <param id="aw_preload" value="true" />
          <param id="aw_use_cdn" value="true" />
        </div>
      </div>
    </Fragment>
  )
}

export default ProtectedSiteStamp
